import { Directionality } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Component,
  computed,
  DestroyRef,
  Directive,
  inject,
  Injector,
  viewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let container: ContainerComponent | undefined = undefined;

@Directive({
  selector: '[idealsToastOutletInner]',
})
export class OutletInnerDirective {
  readonly viewContainerRef = inject(ViewContainerRef);
}

@Component({
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ideals-toast-container',
    fxLayout: 'column',
  },
  imports: [OutletInnerDirective],
  styleUrl: './container.component.scss',
  template: '<ng-template idealsToastOutletInner/>',
})
export class ContainerComponent {
  protected inner = viewChild.required(OutletInnerDirective);

  readonly viewContainerRef = computed(() => this.inner().viewContainerRef);

  static create(injector: Injector): ContainerComponent {
    if (container) {
      return container;
    }

    const overlay = injector.get(Overlay);
    const directionality = injector.get(Directionality);
    const destroyRef = injector.get(DestroyRef);
    const overlayRef = overlay.create({
      hasBackdrop: false,
      panelClass: 'ideals-toast-panel',
      positionStrategy: overlay.position().global().top().right(),
      direction: directionality,
    });

    directionality.change
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(() => {
        overlayRef.setDirection(directionality);
      });

    const portal = new ComponentPortal(ContainerComponent);

    container = overlayRef.attach(portal).instance;

    return container;
  }
}
